import { render, staticRenderFns } from "./ForgetPasswordSuccess.vue?vue&type=template&id=76b7352c&scoped=true&"
import script from "./ForgetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordSuccess.vue?vue&type=style&index=0&id=76b7352c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7352c",
  null
  
)

export default component.exports